import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '@pipes/pipes.module';
import { DebounceDirective } from '@directives/debounce.directive';
import { ComOptionPickerComponent } from './com-option-picker/com-option-picker.component';
import { ComGidFieldComponent } from './com-gid-field/com-gid-field.component';
import { ComPopComponent } from './popup/com-pop/com-pop.component';
import { WarnPopComponent } from './popup/warn-pop/warn-pop.component';
import { ComTitleComponent } from './com-title/com-title.component';
import { ComLoadingComponent } from './com-loading/com-loading.component';
import { ComCaptchaComponent } from './com-captcha/com-captcha.component';
import { ComToastComponent } from './com-toast/com-toast.component';
import { ComErrorComponent } from './com-error/com-error.component';
import { ComCheckItemComponent } from './com-check-item/com-check-item.component';
import { ComDrawerBtmComponent } from './drawer/com-drawer-btm/com-drawer-btm.component';
import { registerLocaleData } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';

import zh from '@angular/common/locales/zh';
registerLocaleData(zh);

import { ComInputComponent } from './com-input/com-input.component';
import { ComPickerInputComponent } from './com-picker-input/com-picker-input.component';
import { ComPhoneFieldComponent } from './com-phone-field/com-phone-field.component';
import { ComBtnComponent } from './btns/com-btn/com-btn.component';
import { ComPwdFieldComponent } from './com-pwd-field/com-pwd-field.component';
import { ComEmailFieldMulanComponent } from './com-email-field/com-email-field.component';
import { ComNameFieldComponent } from './com-name-field/com-name-field.component';
import { DatePickerComponent } from './com-pick/date-picker/date-picker.component';
import { CountryPickerComponent } from './com-pick/country-picker/country-picker.component';
import { CountryPickerWebComponent } from './com-pick/country-picker-web/country-picker-web.component';
import { ImgPreloadDirective } from '@directives/img-preload.directive';

@NgModule({
    declarations: [
        DebounceDirective,
        ImgPreloadDirective,
        ComOptionPickerComponent,
        ComGidFieldComponent,
        ComNameFieldComponent,
        ComPopComponent,
        WarnPopComponent,
        ComTitleComponent,
        ComLoadingComponent,
        ComCaptchaComponent,
        ComToastComponent,
        ComErrorComponent,
        ComCheckItemComponent,
        ComDrawerBtmComponent,
        ComInputComponent,
        ComPickerInputComponent,
        ComPhoneFieldComponent,
        ComBtnComponent,
        ComPwdFieldComponent,
        ComEmailFieldMulanComponent,
        DatePickerComponent,
        CountryPickerComponent,
        CountryPickerWebComponent,
    ],
    imports: [
        CommonModule,
        PipesModule,
        FormsModule,
        RouterModule,
        MatSelectModule
    ],
    exports: [
        ComOptionPickerComponent,
        ComGidFieldComponent,
        ComNameFieldComponent,
        ComPopComponent,
        WarnPopComponent,
        ComTitleComponent,
        ComLoadingComponent,
        ComCaptchaComponent,
        ComToastComponent,
        ComErrorComponent,
        ComCheckItemComponent,
        ComDrawerBtmComponent,
        ComInputComponent,
        ComPickerInputComponent,
        ComPhoneFieldComponent,
        ComBtnComponent,
        ComPwdFieldComponent,
        ComEmailFieldMulanComponent,
        DatePickerComponent,
        CountryPickerComponent,
        CountryPickerWebComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class ComponentsModule { }
